<template>
    <Head>
        <title>Solicitudes de información</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-secretarias-direcciones.png');">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-7">
            <h1 class="hero-encabezado">Solicitudes de información</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="bloque-general">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="contenido-administrable contenido-columna-chica">
              <p>El Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales informa que derivado de la puesta en marcha de la Plataforma Nacional de Transparencia, el pasado cinco de mayo, los Sistemas INFOMEX o similares de los Estados y de la Federación continuarán operando durante el proceso de transición al nuevo esquema informativo nacional; por lo que mediante estos Sistemas podrán realizarse solicitudes de información y en su caso, interponer recursos de revisión.</p>
              <p>Lo anterior, con fundamento en el artículo décimo tercero de los Lineamientos para la Implementación y Operación de la Plataforma Nacional de Transparencia, publicados en el Diario Oficial de la Federación el cuatro de mayo de dos mil dieciséis.</p>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="contenido-administrable">
              <p>Está a tu disposición el Tel (018002CTAINL) para asesorarte sobre tu derecho de acceso a la información.</p>
              <p>De clic aquí para que lo dirija a las dirección electrónica del INFOMEX Nuevo León <a href="http://nl.infomex.org.mx/" target="_blank">http://nl.infomex.org.mx/</a></p>
              <p><a href="https://plataformadetransparencia.org.mx" target="_blank">www.plataformadetransparencia.org.mx</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {

}
</script>
<style scoped>

</style>
